import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Colors from '../../../constants/colors';
import React from 'react';

export default styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.secondary.main,
        color: Colors.WHITE,
        fontSize: 12,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.secondary.main,
    },
}));
